var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogorein01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 776.63 254.58",
    style: {
      enableBackground: "new 0 0 776.63 254.58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#191919;}\n\t.st1{fill:#70C9C0;}\n\t.st2{fill:#52C1B3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.22,18.49h107.12c24.48,0,44.33,7.41,59.55,22.23c15.22,14.82,22.84,33.3,22.84,55.46 c0,8.7-1.19,16.84-3.57,24.43c-2.38,7.59-5.23,13.71-8.57,18.36c-3.34,4.65-6.65,8.65-9.94,11.99c-3.29,3.34-6.2,5.62-8.72,6.83 l-3.34,2.12l41.88,76.17h-72.98l-32.62-62.21H87.01v62.21h-69.8V18.49z M132.31,84.88c-2.98-2.78-7.21-4.17-12.67-4.17H87.01v31.11 h32.62c5.36,0,9.56-1.39,12.6-4.17c3.03-2.78,4.55-6.57,4.55-11.38C136.78,91.45,135.29,87.66,132.31,84.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "759.42,18.5 759.42,236.08 700.39,236.08 618,130.48 618,236.08 548.2,236.08 548.2,18.5 607.23,18.5  689.47,124.25 689.47,18.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.05,
    y: 100.46,
    className: "st1",
    width: 147.48,
    height: 53.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.05,
    y: 179.11,
    className: "st1",
    width: 175.56,
    height: 56.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.05,
    y: 18.52,
    className: "st1",
    width: 175.56,
    height: 56.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518.8,
    y: 98.98,
    className: "st2",
    width: 170.67,
    height: 56.66
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.01,
    y: 18.8,
    className: "st1",
    width: 69.79,
    height: 217.02
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogorein01);
export default __webpack_public_path__ + "static/media/Logorein-01.6a01a03370f636fafcb959cd19c1c9b4.svg";
export { ForwardRef as ReactComponent };